/**
 * @file
 * Subscribe checkboxes JS.
*/
(function ($, Drupal, drupalSettings) {

  'use strict';

  /**
   * Checks all of the checkboxes to see if they're checked, and if so
   * checks the subscribe-all checkbox.
   *
   * @param {jQuery} $checkboxes The list of checkboxes, excluding subscribe-all and unsubscribe-all.
   * @param {jQuery} $subscribe_all The subscribe-all input.
   */
  Drupal.kinaxisSubscribeAllChecked = function ($checkboxes, $subscribe_all) {
    // Assume they're all checked.
    var checked = true;
    // If any of them is unchecked, set our status flag.
    $checkboxes.each(function(index, value) {
      if (!$(this).is(':checked')) {
        checked = false;
      }
    });

    // If they were all checked, adjust the
    // subscribe-all checkbox to checked.
    if (checked) {
      $subscribe_all.prop('checked', true);
    }
  }

  /**
   * Convert block list (links) to carousel at mobile.
   */
  Drupal.behaviors.kinaxisSubscribeCheckboxes = {
    attach: function(context, settings) {
      // All webforms on the page.
      var $webform = $('form.webform-submission-form');

      // For each webform on the page, we need to set up
      // the change events and processing.
      $(once('kinaxisSubscribeCheckboxes', $webform)).each(function () {
        // If you want to omit checkboxes from the "check all" code,
        // add their form item class here.
        var other_input_nots = [
          '.form-item-subscribe-to-all-kinaxis-communications',
          '.form-item-unsubscribe-from-all-kinaxis-communications'
        ];

        // Inputs to add events to and manipulate.
        var $subscribe_all_input = $(this).find('.form-item-subscribe-to-all-kinaxis-communications input[type="checkbox"]');
        var $unsubscribe_input = $(this).find('.form-item-unsubscribe-from-all-kinaxis-communications input[type="checkbox"]');
        var $other_inputs = $(this).find('.form-type-checkbox:not(' + other_input_nots.join('):not(') + ') input[type="checkbox"]');

        // Change event: Subscribe to All checkbox.
        $subscribe_all_input.on('change.subscribed', function (event) {
          var all_checked = $(this).is(':checked');
          // If they subscribe to all, check all the other checkboxes.
          $other_inputs.prop('checked', all_checked);
          // And uncheck the unsubscribe box.
          $unsubscribe_input.prop('checked', !all_checked);
        });

        // Change event: Unsubscribe from All checkbox.
        $unsubscribe_input.on('change.subscribed', function (event) {
          // If they check the unsubscribe box, unset all the
          // other checkboxes.
          if ($(this).is(':checked')) {
            $other_inputs.prop('checked', false);
            $subscribe_all_input.prop('checked', false);
          }
        });

        // Change event: All other checkboxes in the form.
        $other_inputs.on('change.subscribed', function (event) {
          // If a checkbox is checked, they don't want to
          // unsubscribe all, so uncheck that.
          if ($(this).is(':checked')) {
            $unsubscribe_input.prop('checked', false);
          }
          // If a checkbox is unchecked, they don't want to
          // subscribe to all, so uncheck that.
          else {
            $subscribe_all_input.prop('checked', false);
          }

          // If all other_inputs are checked, subscribe to all.
          Drupal.kinaxisSubscribeAllChecked($other_inputs, $subscribe_all_input);
        });
      });
    }
  }

})(jQuery, Drupal, drupalSettings);